import React, { ChangeEvent, FC, useCallback, useMemo, useRef, useState } from "react";
import _ from "lodash";
import F7 from "../../../../utils/F7";
import ImageItem from "./ImageItem";
import Spinner from "../../F7/Spinner";
import * as imageUtils from "../../../../utils/image";
import usePermissions from "../../../../hooks/usePermissions";
import { Field } from "../FieldHandler";
import { ImageObject } from "../../../../hooks/database/types/inventories";
import { useGetImage } from "../../../../utils/image";

async function readFileAsDataUri(file: File) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("error", reject);
    reader.addEventListener("load", () => resolve(reader.result as string));
    reader.readAsDataURL(file);
  });
}

const ImageField: FC<{
  field: Field & { type: "image" };
  onChange: (key: string, value: ImageObject[]) => void;
}> = (props) => {
  const [loading, setLoading] = useState(false);
  const { canAddImage } = usePermissions();

  const values = useMemo(() => props.field.value || [], [props]);

  const handleChange = useCallback(
    (images: ImageObject[]) => {
      props.onChange(props.field.key, images);
    },
    [props]
  );

  const handleImageRemove = useCallback(
    (index: number) => {
      const imagesCopy = _.clone(values);
      imagesCopy.splice(index, 1); //remove element
      handleChange(imagesCopy);
    },
    [handleChange, values]
  );

  const addImageWeb = useCallback(
    async (e: ChangeEvent<HTMLInputElement>) => {
      setLoading(true);
      const results = await Promise.all(
        Array.from(e.target.files!).map(async (file) => {
          const imageUri = await readFileAsDataUri(file);
          const thumbnailUri = await imageUtils.resize(imageUri, 120);
          return {
            imageUri,
            thumbnailUri,
          };
        })
      );
      setLoading(false);
      handleChange([...values, ...results]);
    },
    [handleChange, values]
  );

  const getImage = useGetImage();
  const handleImageClick = useCallback(
    async (index: number) => {
      setLoading(true);
      const imageUrls = await Promise.all(values.map((image) => getImage(image)));
      setLoading(false);
      const myPhotoBrowserPopup = F7.photoBrowser({
        photos: imageUrls,
        type: "popup",
        initialSlide: index,
      });

      myPhotoBrowserPopup.open();
    },
    [getImage, values]
  );

  const fileuploadRef = useRef<HTMLInputElement | null>(null);

  return (
    <div>
      {loading ? <Spinner /> : null}
      <div className="list-block media-list">
        <ul
          style={{
            paddingLeft: "initial",
          }}
        >
          {values.map((image, index) => (
            <ImageItem
              key={index}
              index={index}
              image={image}
              onClick={() => handleImageClick(index)}
              onImageTrashcanClick={() => handleImageRemove(index)}
            />
          ))}
        </ul>
      </div>
      <div
        style={{
          marginTop: -27,
          marginBottom: 10,
        }}
      >
        {canAddImage ? (
          <div>
            <input
              style={{
                display: "none",
              }}
              type="file"
              accept="image/*"
              capture="environment"
              onChange={addImageWeb}
              multiple
              ref={fileuploadRef}
            />
            <button
              onClick={() => {
                fileuploadRef.current!.click();
              }}
              onTouchEnd={() => {
                fileuploadRef.current!.click();
              }}
              className="button button-fill"
              style={{
                marginTop: -27,
                marginBottom: 10,
                backgroundColor: "#444",
              }}
            >
              Add image
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ImageField;
